import React from 'react';

import { ICONS } from 'shared/presentation/constants';

import * as S from './styles';

type TChannelType = 'sms' | 'email' | 'whatsapp';

interface IChannelOptionCardProps {
  type: TChannelType;
  value: string;
  onClick?: () => void;
  disabled: boolean;
}

const channelLabels: Record<TChannelType, string> = {
  sms: 'SMS',
  email: 'E-mail',
  whatsapp: 'Whatsapp',
};

const channelIcons: Record<TChannelType, React.ElementType> = {
  sms: ICONS.PHONE,
  email: ICONS.MAIL,
  whatsapp: ICONS.WHATSAPP,
};

const ChannelOptionCard: React.FC<IChannelOptionCardProps> = ({
  type,
  value,
  onClick,
  disabled = false,
}) => {
  const Icon = channelIcons[type];

  return (
    <S.Container type="button" onClick={onClick} disabled={disabled}>
      <div>
        <Icon />

        <span>
          {channelLabels[type]} {value}
        </span>
      </div>

      <ICONS.CHEVRON_RIGHT />
    </S.Container>
  );
};

export default ChannelOptionCard;
